











import { Component, Prop, Vue } from "vue-property-decorator";
import BtnChangeDate from "./BtnChangeDate.vue";
import { Instance } from "flatpickr/dist/types/instance";
import PickerInput from "@/components/List/DatePicker/PickerInput.vue";

@Component({
  components: { PickerInput, BtnChangeDate }
})
export default class Header extends Vue {
  @Prop() readonly isOpen!: boolean;
  @Prop({ default: undefined }) readonly datePicker: Instance | undefined;
}
